package net.frozenbit.games.soundgame.viewmodels.presentation

data class SoundCreation(
    val highlighted: Boolean,
    val play1Indicator: Boolean,
    val line1: String,
    val line1Visible: Boolean,
    val play2Indicator: Boolean,
    val line2: String,
    val line2Visible: Boolean,
)